import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/csir_logo.png";
import { FaSignOutAlt,FaUserCircle, FaUserEdit } from "react-icons/fa";
import { useGetUserPictureQuery } from "../store/apis/userApi";
import { useLogoutUserQuery} from '../store/apis/authApi';
import { authApi } from "../store/apis/authApi";
import { Api } from "../store/apis/api";
import EditProfile from "../pages/EditProfile";

export default function Navbar({ links =[] , isScrolled }) {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation().pathname;

  const { data } = useGetUserPictureQuery();
  
  const profilePicture = data?.photo;

  const { data:logout } = useLogoutUserQuery();

  const [isProfileOpen, setIsProfileOpen] = useState(false); // State for modal

  const handleSignOut = () => {
    const answer = window.confirm("Are you sure you want to logout?");
    if (answer) {
        try {
            if (logout.status === "success") {

                // Clear storage
                sessionStorage.removeItem("tokens"); 
                sessionStorage.removeItem("api_key");
                sessionStorage.removeItem("user");

                // reset RTK Query cache to avoid stale data
                dispatch(authApi.util.resetApiState());
                dispatch(Api.util.resetApiState());
                
                // Redirect to home or login page
                navigate("/"); 
            }  else {
              throw new Error("Logout failed.");
            }
        } catch (error) {
            console.error("Error during logout:", error);
            alert("Error: failed to logout.");
            sessionStorage.removeItem("tokens"); 
            dispatch(authApi.util.resetApiState());
            dispatch(Api.util.resetApiState());
            navigate("/");
        }     
    }    
  };

 
  return (
    <>
      <Container>
        <nav className={`${isScrolled ? "scrolled" : ""} flex`}>
          <div className="left flex a-center">
            <div className="brand flex a-center j-center">
              <img src={logo} alt="Logo" style={{width:'133px', height: '45px'}} />
            </div>
            <ul className="links flex">
              {links.map(({ name, link }) => (
                <li
                  key={name}
                  style={
                    location === link
                      ? { fontWeight: "bold", textDecorationLine: "underline" }
                      : { fontWeight: "normal", textDecorationLine: "none" }
                  }
                >
                  <Link to={link}>{name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="right flex a-center">
            <ProfileButton onClick ={() => setIsProfileOpen(!isProfileOpen)} aria-label="Open profile menu">
              {profilePicture ? (
                <img src={profilePicture} alt="Profile" />
              ) : (
                <FaUserCircle size={30} color="#FFFFFF" /> // Use the user icon as fallback
              )}
            </ProfileButton>
            {isProfileOpen && (
              <DropdownMenu onClick={(e) =>e.stopPropagation()}>
                <ul>
                  <li onClick={() => navigate("/editProfile")}>
                    <FaUserEdit size={18} className="icon" />Edit Profile

                  </li>
                  <li onClick={handleSignOut}>
                    <FaSignOutAlt size={18} className="icon logout-icon"/>Logout
                  </li>
                </ul>
              </DropdownMenu>
            )}
          </div>
        </nav>
      </Container>
    </>
  );
}

const Container = styled.div`
  .scrolled {
    background-color: #2A3439;
  }
  nav {
    position: sticky;
    top: 0;
    left: 0;
    height: 4rem;
    width: 100%;
    justify-content: space-between;
    position: fixed;
    z-index: 2;
    padding: 0 4rem;
    align-items: center;
    transition: 0.3s ease-in-out;
    .left {
      gap: 2rem;
      .brand img {
        height: 3rem;
      }
      .links {
        list-style-type: none;
        gap: 2rem;
        li a {
          color: white;
          text-decoration: none;
        }
      }
    }
    .right {
      gap: 2rem;
      display: flex;
      align-items: center;
    }
  }
`;

const ProfileButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  
  img {
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    object-fit: cover;
    :hover {
      cursor: pointer;
    }
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 70px;
  right: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 170px;
  z-index: 100;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      color: #333;
      transition: background 0.2s ease-in-out;

      .icon {
        color: #2a3439;
      }

      .logout-icon {
        color: #E55B41;
      }

      &:hover {
        background: #f5f5f5;
      }
    }
  }
`;